<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list">
          {{ this.parentRoute.menuName }}-{{ title }}科室请领
        </span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">请领基础信息</span>
          </div>
          <el-row>
            <el-col :span="6">
              <el-form-item label="请领单号" prop="no">
                <el-input disabled v-model="form.no" placeholder="系统自动生成请领单号" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="请领科室" prop="deptName">
                <el-select :disabled="!editMode" v-model="form.deptName" style="width: 90%" filterable placeholder="请选择请领科室" :filter-method="getDepts" @change="deptChange">
                  <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人" prop="createdUserName">
                <el-input v-model="form.createdUserName" disabled style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建时间" prop="createdTime">
                <el-date-picker v-model="form.createdTime" disabled type="datetime" placeholder="系统自动带出创建时间" style="width: 90%">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="请领日期" prop="date">
                <el-date-picker :disabled="!editMode" v-model="form.date" style="width: 90%" type="date" value-format="yyyy-MM-dd" placeholder="请选择入库日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="请领人" prop="applyUserName">
                <el-select :disabled="!editMode" v-model="form.applyUserName" style="width: 90%" filterable placeholder="请选择请领人" :filter-method="getApplyUser" @change="userChange">
                  <el-option v-for="item in applyUserOptions" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="保管人" prop="custodianName">
                <el-select :disabled="!editMode" v-model="form.custodianName" style="width: 90%" filterable placeholder="请选择请领人" :filter-method="getUsers" @change="custodianChange">
                  <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.no + ' ' + item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="目标库房" prop="warehouseName">
                <el-select :disabled="!editMode" v-model="form.warehouseName" style="width: 90%" filterable placeholder="请选择入库库房" :filter-method="getWarehouses" @change="warehouseChange">
                  <el-option v-for="item in STATIC_Warehouses" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="库管员" prop="warehouseManagerName">
                <el-input disabled v-model="form.warehouseManagerName" placeholder="系统自动带出库管员" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="请领总数量" prop="totalNumber">
                <el-input disabled v-model="form.totalNumber" placeholder="系统自动带出总数量" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="请领总金额" prop="totalAmount">
                <el-input disabled v-model="form.totalAmount" placeholder="系统自动带出总金额" style="width:90%"></el-input>
              </el-form-item>
            </el-col> -->
            <!-- <el-col :span="6">
              <el-form-item label="责任科室" prop="dutyDeptName">
                <el-select
                  :disabled="!editMode"
                  v-model="form.dutyDeptName"
                  placeholder="请选择责任科室"
                  style="width: 90%"
                  filterable
                  :filter-method="getDepts"
                  @change="dutyDeptChange"
                >
                  <el-option
                    v-for="item in STATIC_Depts"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="责任人" prop="dutyUserName">
                <el-select
                  :disabled="!editMode"
                  v-model="form.dutyUserName"
                  placeholder="请选择责任人"
                  style="width: 90%"
                  filterable
                  :filter-method="getDutyUser"
                  @change="dutyUserChange"
                >
                  <el-option
                    v-for="item in dutyUserOptions"
                    :key="item.id"
                    :label="item.no + ' ' + item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <!-- </el-row>

          <el-row> -->
            <el-col :span="6">
              <el-form-item label="存放地点" prop="address">
                <el-input v-model="form.address" :disabled="!editMode" placeholder="请填写存放地点" style="width: 90%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input :disabled="!editMode" v-model="form.remark" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width: 95%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">科室领用详情</span>
          </div>

          <div v-if="editMode" style="margin: 20px 0 12px 10px">
            <el-button class="btn default" size="small" v-preventReClick @click="handleAddChildForm">新增明细</el-button>
            <el-button class="btn" size="small" type="danger" :disabled="childMultiple" v-preventReClick @click="handleDeleteChildForm">删除</el-button>
          </div>
          <div v-else style="margin-top: 20px"></div>

          <el-table ref="childTable" :data="form.details" style="width: auto; margin: 0 10px" @cell-dblclick="cellDblclick" @selection-change="handleChildSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <el-table-column align="center" type="selection" fixed width="55" v-if="editMode">
            </el-table-column>
            <el-table-column show-overflow-tooltip label="资产编码" align="center" min-width="140" prop="fixedAssetNo" />
            <el-table-column show-overflow-tooltip label="资产名称" align="center" min-width="130" prop="fixedAssetName" />
            <!-- <el-table-column show-overflow-tooltip label="资产卡号" align="center" min-width="130" prop="fixedAssetCards" /> -->
            <el-table-column show-overflow-tooltip label="规格型号" align="center" min-width="130" prop="specName" />
            <!-- <el-table-column show-overflow-tooltip label="单位" align="center" min-width="80" prop="unitName" /> -->
            <!-- <el-table-column show-overflow-tooltip label="品牌" align="center" min-width="100" prop="brandName" /> -->
            <el-table-column show-overflow-tooltip label="资产类型" align="center" min-width="130" prop="assetTypeName" />
            <el-table-column show-overflow-tooltip label="请领数量" align="center" min-width="80" prop="number" />
            <el-table-column show-overflow-tooltip label="空闲数量" align="center" min-width="80" prop="stockNumber" />
            <el-table-column show-overflow-tooltip label="已领数量" align="center" min-width="80" prop="receivedNumber" />
            <el-table-column show-overflow-tooltip label="未领数量" align="center" min-width="80" prop="notReceivedNumber" />

            <!-- <el-table-column show-overflow-tooltip label="单价" align="center" min-width="80" prop="price" />
            <el-table-column show-overflow-tooltip label="金额" align="center" min-width="100" prop="amount" /> -->
            <el-table-column show-overflow-tooltip label="产地类型" align="center" min-width="80" prop="productionPlaceName" />
            <el-table-column show-overflow-tooltip label="生产厂家" align="center" min-width="130" prop="manufacturerName" />
            <!-- <el-table-column show-overflow-tooltip label="供应商" align="center" min-width="130" prop="supplierName" /> -->
          </el-table>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>

      <el-dialog title="资产信息" :visible.sync="openSubformModal" :center="true" width="1100px" :before-close="cancelChildDialog" :close-on-click-modal="false">
        <el-form label-position="top" ref="childForm" :model="childForm" :rules="childFormRules">
          <el-row>
            <el-col>
              <span>资产编号：{{ childForm.fixedAssetNo }}</span>
              <span style="color: #909399; margin-left: 30px" v-if="Boolean(childForm.assetId)">
                当前台资产空闲{{ childForm.stockNumber }}台</span>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="资产编号" prop="fixedAssetNo">
                <SelectTable :disabled="!editMode" :columns="assetAndStockNumberColumns" :placeholder="'请选择资产编号'" :innerName="childForm.fixedAssetNo" :dataList="assetList" @filterMethod="getFixedAssetList" @change="selectAsset" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="资产名称" prop="name">
                <el-input disabled v-model="childForm.fixedAssetName" placeholder="系统自动带出资产名称" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="规格型号" prop="specName">
                <el-input disabled v-model="childForm.specName" placeholder="系统自动带出规格型号" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="品牌" prop="brandName">
                <el-input disabled v-model="childForm.brandName" placeholder="系统自动带出品牌" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="6">
              <el-form-item label="资产类型" prop="assetTypeName">
                <el-input disabled v-model="childForm.assetTypeName" placeholder="系统自动带出资产类型" />
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="单位" prop="unitName">
                <el-input disabled v-model="childForm.unitName" placeholder="系统自动带出单位" />
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="请领数量" prop="number">
                <el-input-number :disabled="!editMode" v-model="childForm.number" :precision="0" :min="1" :controls="false" placeholder="请填写请领数量" @change="childNumberChange" style="width: 100%"></el-input-number>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="单价" prop="price">
                <el-input disabled v-model="childForm.price" placeholder="请填写单价" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="金额" prop="amount">
                <el-input disabled v-model="childForm.amount" placeholder="系统自动带出退货金额" />
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="产地类型" prop="productionPlaceName">
                <el-input disabled v-model="childForm.productionPlaceName" placeholder="系统自动带出产地类型" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="生产厂家" prop="manufacturerName">
                <!-- <el-select :disabled="!editMode" v-model="childForm.manufacturerName" style="width: 90%" filterable placeholder="请选择生产厂家" :filter-method="getManufacturers" @change="manufacturerChange">
                  <el-option v-for="item in STATIC_Manufacturers" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select> -->
                <el-input disabled v-model="childForm.manufacturerName" placeholder="系统自动带出生产厂家" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="">
          <el-button v-if="editMode" class="btn primary" type="primary" size="small" v-preventReClick @click="continueAdd">新增下一条</el-button>
          <el-button class="btn" size="small" v-preventReClick @click="cancelChildDialog">取 消</el-button>
          <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submitChildForm">确 定</el-button>
        </div>
      </el-dialog>

      <!-- <el-image-viewer :openViewer="openViewer" :fileId="fileId" :fileName="fileName" @closeImageViewer="closeImageViewer" /> -->
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="$router.go(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
  GetDeptClaimById,
  SaveDeptClaim,
  GetFixedAssetStockInfos,
  RejectDeptClaim,
} from "@/api";
import { WhetherOptions } from "@/enum";
import SelectTable from "@/components/select-table";
import ApproveInfo from "@/components/approve-info";

export default {
  name: "manufacturerEdit",
  mixins: [GetDataMixin],
  components: {
    SelectTable,
    ApproveInfo,
  },
  data () {
    return {
      form: {},
      WhetherOptions: WhetherOptions,
      rules: {
        date: [
          { required: true, message: "请领科室不能为空", trigger: "blur" },
        ],
        applyUserName: [
          { required: true, message: "请领人不能为空", trigger: "blur" },
        ],
        warehouseName: [
          { required: true, message: "目标库房不能为空", trigger: "blur" },
        ],
        date: [
          { required: true, message: "请领日期不能为空", trigger: "blur" },
        ],
        dutyDeptName: [
          { required: true, message: "责任科室不能为空", trigger: "blur" },
        ],
        dutyUserName: [
          { required: true, message: "责任人不能为空", trigger: "blur" },
        ],
        address: [
          { required: true, message: "存放地点不能为空", trigger: "blur" },
        ],
      },
      childFormRules: {
        fixedAssetNo: [
          { required: true, message: "资产编码不能为空", trigger: "blur" },
        ],
        number: [
          { required: true, message: "请领数量不能为空", trigger: "blur" },
        ],
      },
      editMode: false,
      showWorkFlowInfo: false,
      assetList: [],
      reject: RejectDeptClaim,
      // 子表
      childIds: [],
      childMultipleSelection: [],
      childMultiple: true,
      openSubformModal: false,
      childForm: {},
      applyUserOptions: [],
      dutyUserOptions: [],
    };
  },

  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    this.getUsers();
    this.getApplyUser("");
    this.getDutyUser();
    this.getDepts("");
    this.getWarehouses("");
    this.getFixedAssetList("");
  },
  methods: {
    // 新建
    handleAdd () {
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      GetDeptClaimById({ id }).then((res) => {
        // this.resetForm()
        this.form = res.returnData;

        this.getFixedAssetList("");

        this.initWorkFlowProperty(this.form);
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });
      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        SaveDeptClaim(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          this.$router.push({ path: this.getMainPath(this.$route.path) });
        }).finally(() => {
          this.$store.dispatch('SetLoading',false)
        });;
      });
    },
    resetForm () {
      this.form = {
        inStockType: 0,
        supplierId: "",
        supplierName: "",
        warehouseId: "",
        warehouseName: "",
        state: 0,
        details: [],
        deptId: this.userInfo.deptId,
        deptName: this.userInfo.deptName,
        applyUserId: this.userInfo.id,
        applyUserName: this.userInfo.name,
        createdTime: this.parseTime(new Date()),
        updateTime: this.parseTime(new Date()),
        createdUserName: this.userInfo.name,
        ownerDeptName: this.userInfo.deptName,
        date: this.parseTime(new Date(), "{y}-{m}-{d}"),
        orgCode :sessionStorage.getItem('orgId')
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      this.$router.push({ path: this.getMainPath(this.$route.path) });
    },

    // 明细表
    handleAddChildForm () {
      if (!this.form.details) {
        this.form.details = [];
      }
      this.openSubformModal = true;
      this.editChildren = false;
      this.resetDetailFormData();
    },
    handleDeleteChildForm () {
      this.form.details = this.form.details.filter(
        (i) => !this.childIds.includes(i.$index)
      );
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });
      this.autoTotalAmount();
    },
    handleChildSelectionChange (selection) {
      this.childMultipleSelection = selection;
      this.childIds = selection.map((item) => item.$index);
      this.childMultiple = !selection.length;
    },
    cellDblclick (row, column, cell, event) {
      // 打开子表弹窗
      this.openSubformModal = true;
      this.editChildren = true;
      this.resetDetailFormData();
      this.childForm = JSON.parse(JSON.stringify(row));
    },

    resetDetailFormData () {
      this.childForm = {
        $index: this.form.details.length + 1,
        fixedAssetNo: "",
        name: "",
        number: 0,
        receivedNumber: 0,
        notReceivedNumber: 0,
        price: 0,
        amount: 0,
        remark: "",
      };
    },
    cancelChildDialog () {
      this.openSubformModal = false;
    },
    submitChildForm () {
      this.pushChildForm(true);
    },
    continueAdd () {
      this.editChildren = false;
      this.pushChildForm();
    },
    pushChildForm (close) {
      this.$refs["childForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.childForm.orgCode = sessionStorage.getItem('orgId')
        this.$set(this.childForm, "notReceivedNumber", this.childForm.number);
        // this.capitalSourceChange()

        let item = this.form.details.find(
          (e) => e.assetId == this.childForm.assetId
        );
        if (item && !this.editChildren) {
          // 新增有重复项提示
          // Object.assign(item, this.childForm);
          this.$my_message(`当前资产信息已存在，请去子表编辑！`, "error");
          return;
        } else if (item && this.editChildren) {
          // 编辑且有重复项
          this.$my_message(`当前资产信息已存在，请去子表编辑！`, "error");
          return;
        } else if (!item && this.editChildren) {
          // 编辑
          item = this.form.details.find((e) => e.$index == this.childForm.$index);
          Object.assign(item, this.childForm);
        } else {
          this.form.details.push(this.childForm);
        }

        this.autoTotalAmount();
        this.resetDetailFormData();
        if (close) {
          this.openSubformModal = false;
        }
      });
    },
    childNumberChange () {
      this.autoAmount();
    },
    autoAmount () {
      this.childForm.amount =
        (this.childForm.number * this.childForm.price).toFixed(2) * 1;
    },
    autoTotalAmount () {
      let totalNumber = 0;
      let totalAmount = 0;
      this.form.details.forEach((element, index) => {
        // 重置表格数据的序号
        element.$index = index + 1;
        totalNumber = totalNumber * 1 + element.number * 1;
        totalAmount = totalAmount * 1 + element.amount * 1;
      });
      this.form.totalNumber = totalNumber;
      this.form.totalAmount = totalAmount;
    },

    // change event
    selectAsset (row) {
      this.childForm = Object.assign(this.childForm, row, {
        fixedAssetNo: row.no,
        fixedAssetName: row.name,
        assetId: row.id,
        remark: "",
        id: 0,
        number: 1,
        stockState: row.state,
      });
    },
    dutyDeptChange (val) {
      this.form.dutyDeptId = val;
      this.getDutyUser();
    },
    deptChange (val) {
      this.form.deptId = val;
      this.getApplyUser();
    },
    dutyUserChange (val) {
      this.form.dutyUserId = val;
    },
    userChange (val) {
      this.form.applyUserId = val;
    },
    custodianChange (val) {
      this.form.custodianId = val;
    },
    warehouseChange (val) {
      let item = this.STATIC_Warehouses.find((e) => e.id == val);
      if (item) {
        this.form.warehouseId = item.id;
        this.form.warehouseManagerId = item.managerId;
        this.form.warehouseManagerName = item.managerName;
      }
      this.getFixedAssetList("");
    },

    getFixedAssetList (keyWord) {
      GetFixedAssetStockInfos({
        keyWord: keyWord,
        state: 1,
        pageSize: 50,
        pagIndex: 1,
        warehouseId: this.form.warehouseId,
      }).then((res) => {
        this.assetList = res.returnData.data;
      });
    },
    getDutyUser (keyWord) {
      this.getDeptUsers(this.form.dutyDeptId, keyWord).then((res) => {
        this.dutyUserOptions = res;
      });
    },
    getApplyUser (keyWord) {
      this.getDeptUsers(this.form.deptId, keyWord).then((res) => {
        this.applyUserOptions = res;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-input-number .el-input__inner {
  text-align: left !important;
}
</style>
